import '../styles/Pod.scss';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faWindowRestore } from '@fortawesome/free-regular-svg-icons';
import { ChartProps } from '../Interfaces/Charts';
import { DESCRIPTION_MESSAGE, DOWNLOAD_MESSAGE, POPOUT_MESSAGE } from '../Constants';
import { useLocation } from 'react-router';
import Disclaimer from './Disclaimer';

type PodProps = {
    title: string;
    showPopout?: boolean;
    Chart: React.FC<ChartProps & any>;
    hideTitleBar?: boolean;
    hideDisclaimer?: boolean;
    chartSpecificProps?: any;
    removeChartArea?: boolean;
    hideDownload?: boolean; // <-- added prop
};

export default function Pod(props: PodProps) {
    const location = useLocation();
    const hideTitleBarUrl = new URLSearchParams(location.search).get('hideTitleBar');
    const hideDisclaimerUrl = new URLSearchParams(location.search).get('hidedisclaimer') === 'true' || new URLSearchParams(location.search).get('hideDisclaimer') === 'true';
    const showPopoutUrl = new URLSearchParams(location.search).get('showpopout') === 'true';
    const removeChartAreaUrl = new URLSearchParams(location.search).get('removeChartArea') === 'true';
    const hideDownloadUrl = new URLSearchParams(location.search).get('hideDownload') === 'true';

    let {
        title,
        showPopout,
        Chart,
        hideTitleBar,
        hideDisclaimer,
        chartSpecificProps,
        removeChartArea,
        hideDownload // <-- added here
    } = props;

    const [buttonClicked, setButtonClicked] = useState("");

    if (hideTitleBar === null || hideTitleBar === undefined) {
        hideTitleBar = hideTitleBarUrl === 'true';
    }

    if (hideDisclaimer === null || hideDisclaimer === undefined) {
        hideDisclaimer = hideDisclaimerUrl;
    }

    if (showPopout === null || showPopout === undefined) {
        showPopout = showPopoutUrl;
    }

    if (removeChartArea === null || removeChartArea === undefined) {
        removeChartArea = removeChartAreaUrl;
    }

    if (hideDownload === null || hideDownload === undefined) {
        hideDownload = hideDownloadUrl;
    }

    useEffect(() => {
        if (buttonClicked === '') return;
        setButtonClicked('');
    }, [buttonClicked]);

    return (
        <div className='pod' style={{ height: "100%" }}>
            <div className='pod-container'>
                <div className="pod-container-titlebar" hidden={hideTitleBar}>
                    <div className="col-xs-9 titlebar-title">
                        <span>{title}</span>
                    </div>
                    <div className='col-xs-3 pull-right titlebar-buttons'>
                        <span title="Toggle Description" className="miso-icon miso-icon-info">
                            <FontAwesomeIcon icon={faInfoCircle} size="xs" onClick={() => setButtonClicked(DESCRIPTION_MESSAGE)} />
                        </span>
                        {!hideDownload && (
                            <span title="Download Data" className="miso-icon miso-icon-download">
                                <FontAwesomeIcon icon={faDownload} size="xs" onClick={() => setButtonClicked(DOWNLOAD_MESSAGE)} />
                            </span>
                        )}
                        {
                            showPopout && <span title="Open the pod in a new tab" className="miso-icon miso-icon-popout">
                                <FontAwesomeIcon icon={faWindowRestore} size="xs" onClick={() => setButtonClicked(POPOUT_MESSAGE)} />
                            </span>
                        }
                    </div>
                </div>
                <div className='chart-container'>
                    <div className={removeChartArea ? 'chart-area-no-padding' : 'chart-area'}>
                        <Chart buttonClicked={buttonClicked} {...chartSpecificProps} />
                    </div>
                </div>
            </div>
            {!hideDisclaimer && <Disclaimer extraMargin={false} />}
        </div>
    );
}